<template>
  <section class="courses">
    <h2 v-if="$slots.title" class="title-highlight">
      <slot name="title" />
    </h2>
    <SliderInfinite class="slider" :offset="offset">
      <CourseCard
        v-for="(course, idx) in coursesMapped" :key="course.id"
        slot="slide"
        dark :course="course"
        target-blank
        :heading="heading"
        class="card" :class="`id-${idx}`"
      />
    </SliderInfinite>
  </section>
</template>

<script>
import SliderInfinite from '@itbpbg/lms-components/src/components/SliderInfinite';
import CourseCard from '@itbpbg/lms-components/src/Courses/Card';

export default {
  components: {
    SliderInfinite,
    CourseCard,
  },
  props: {
    courses: { type: Array, default: () => ([]), required: true },
    coursesMap: { type: Array, default: () => ([]), required: false },
    heading: { type: String, default: 'div', required: false },
    offset: { type: Number, default: 0 },
  },
  computed: {
    coursesMapped() {
      if (!this.coursesMap.length) {
        return this.courses;
      }

      return this.coursesMap.map((id) => {
        if (typeof id === 'object') {
          return id;
        }

        return this.courses.find((course) => course.id === id);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.courses {
  padding-top: var(--spacing-60);
  padding-bottom: var(--spacing-60);

  .module-description {
    color: var(--main-light-shade-4);
    text-align: center;
    font-size: 21px;
    line-height: 140%;
  }

  .btn-primary {
    margin-top: var(--spacing-50);
  }

  @include bp($bp-mobile) {
    .title-highlight {
      padding: 0 24px;
    }

    .module-description {
      display: block;
      font-size: 18px;
      line-height: 150%;
      text-align: center;
      color: var(--main-dark-shade-4);
      padding: 0 var(--spacing-24);
    }
  }
}
</style>
